<template>
  <div>
    <!-- <pre>  {{lessonContent}}</pre> 
      {{lessonIndex}}
      {{TopicIndex}} -->
     <!-- <pre> {{topics}}</pre> -->
    <h3 class="course-heading">{{ topics.topic.name }}</h3>
    <div class="cstm-breadcrumb">
      <p class="bread-menus" @click="redirectBackToContent()">
        {{ lessonContent.name }}
      </p>
      <p class="bread-menus" @click="redirectBackToLesson()">
        {{ lessonContent.courseLessons[lessonIndex].lesson.name }}
      </p>
      <p class="bread-menus">{{ topics.topic.name }}</p>
    </div>
    <!-- description about lesson -->
    <div class="desc-container">
      <p v-if="summary">
        {{ topics.topic.description | limitTo(200) }}
        <a @click="summary = false" >Read more</a>
      </p>
      <p v-else>
        {{ topics.topic.description }}
        <a @click="summary = true" >200">Read less</a>
      </p>
    </div>
    <vs-tabs class="cstm-card">
      <vs-tab label="Content" icon-pack="feather" icon="icon-align-justify">
        <vs-card v-if="topics.topic.topic_content.content">
          <p v-html="topics.topic.topic_content.content"></p>
        </vs-card>
      </vs-tab>
      <vs-tab label="Files" icon-pack="feather" icon="icon-file">
        <div>
          <div
            v-for="(eachFiles, index) in topics.topic.topic_files"
            :key="index"
            class="sm:w-1/2 md:w-1/3 lg:w-1/4 px-2"
          >
            <vs-card class="file-card">
              <div slot="header">
                <img
                  class="w-full file-image"
                  :src="eachFiles.file.file_path"
                  alt=""
                />
              </div>
              <h5 class="file-name">{{ eachFiles.file.file_name }}</h5>
              <p>{{ eachFiles.file.size }}</p>
              <!-- <a class="float-right" href="#"
                ><feather-icon icon="DownloadIcon"
              /></a> -->
               <vs-button color="success" 
                                      class="float-right"
                                      type="flat" @click="downloadImage(eachFiles.file)" icon-pack="feather" icon="icon-download"></vs-button>
            </vs-card>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>

    <vs-row vs-w="12">
      <vs-col type="flex" vs-w="4">
        <vs-button

        v-if="TopicIndex == 0"

          icon-pack="feather"
          icon="icon-chevron-left"
          @click="redirectBackToLesson()"
          >          {{ lessonContent.courseLessons[lessonIndex].lesson.name }}
</vs-button
        >
        <vs-button

        v-else

          icon-pack="feather"
          icon="icon-chevron-left"
          @click="redirectNextTopic(-1)"
          >          {{
            lessonContent.courseLessons[lessonIndex].lesson.lesson_topics[
              this.TopicIndex - 1
            ].topic.name
          }}
</vs-button
        >
      </vs-col>
      <!-- {{topics.topic.topic_complete_count}} -->
      <!-- <vs-col type="flex" vs-w="4" v-if="topics.topic.topic_complete_count === 0"> 
        <vs-button color="success"
          type="border"
        @click="saveComplete(topics.topic.id)"
          >Mark As Complete</vs-button
        >
      </vs-col>

      <vs-col type="flex" vs-w="4" v-else>
        
        <vs-button color="success" icon-pack="feather" icon="icon-check"
          >Completed</vs-button
        >
      </vs-col> -->
      <!-- {{lessonContent.courseLessons.length}} -->
      <!-- {{lessonContent.courseLessons[0].lesson.lesson_topics.length}} -->
      <!-- {{lessonContent.courseLessons[lessonIndex].lesson.lesson_topics.length}} -->
      <!-- {{TopicIndex}} -->
      <vs-col type="flex" vs-w="4">
        <vs-button
          v-if="
            lessonContent.courseLessons[lessonIndex].lesson.lesson_topics
              .length -
              1 !=
            TopicIndex
          "
          icon-pack="feather"
          icon="icon-chevron-right"
          icon-after
          @click="redirectNextTopic(1)"
        >
          {{
            lessonContent.courseLessons[lessonIndex].lesson.lesson_topics[
              this.TopicIndex + 1
            ].topic.name
          }}
        </vs-button>

        <vs-button
          v-if="
            lessonContent.courseLessons.length - 1 != lessonIndex &&
            lessonContent.courseLessons[lessonIndex].lesson.lesson_topics
              .length -
              1 ==
              TopicIndex
          "
          icon-pack="feather"
          icon="icon-chevron-right"
          icon-after
          @click="redirectNextLesson()"
        >
          {{ lessonContent.courseLessons[lessonIndex + 1].lesson.name }}
        </vs-button>
      </vs-col>

    </vs-row>
  </div>
</template>

<script>
// import {MarkCompleteMixin} from '../mixins/MarkCompleteMixin'
import axios from 'axios'


export default {
  props: {
    lessonContent: {
      type: Object,
      required: true,
      default: () => {}
    },
    lessonIndex: {type:Number,
      default:null},
    TopicIndex: {type:Number,
      default:null}
  },
  // mixins:[MarkCompleteMixin],

  mounted () {},
    
  created () {
    this.topics = this.lessonContent.courseLessons[
      this.lessonIndex
    ].lesson.lesson_topics[this.TopicIndex]
  },
  
  data () {
    return {
      topics: '',
      summary: false
    }
  },
  methods: {
    redirectBackToContent () {
      
      this.$emit('backToContent')
    },
    redirectBackToLesson () {
      // 
      this.$emit('backToLesson', this.lessonIndex)
    },
    redirectNextLesson () {
      this.$emit('backToLesson', this.lessonIndex + 1)
    },
    redirectNextTopic (index) {
      this.$emit('backToTopic', this.lessonIndex, this.TopicIndex + index)
    },
    saveComplete (topic_id) {
      
      const payload = {
        topic_id,
        type:3
      }


      const isMarkDone = this.markComplete(payload)
      if (isMarkDone) {
        
        this.topics.topic.topic_complete_count = 1
      }
    },
    downloadImage (item) {
      
      axios({
        url: `https://cors-anywhere.herokuapp.com/${  item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileUrl

        fileLink.setAttribute('download', item.file_name)
        document.body.appendChild(fileLink)

        fileLink.click()
      }).catch(error => {
        
      }).finally(() => {
        

      })

    }
  },
  filters: {
    limitTo (value) {
      if (!value) return ''
      return `${value.substring(0, 200)}...`
    }
  },

  watch: {
    lessonIndex () {
      this.topics = this.lessonContent.courseLessons[
        this.lessonIndex
      ].lesson.lesson_topics[this.TopicIndex]
    },
    TopicIndex () {
      this.topics = this.lessonContent.courseLessons[
        this.lessonIndex
      ].lesson.lesson_topics[this.TopicIndex]
    }
  }
}
</script>